import { createArchiveViewedEvent } from '../domain/analyticsEvent';
import { getAnalyticsAttribution } from '../infrastructure/analyticsAttribution';
import {
  createAnalyticsEventId,
  getAnalyticsIdentity,
} from '../infrastructure/analyticsIdentity';
import { sendAnalyticsEvent } from '../infrastructure/analyticsTransport';

export const trackArchiveViewed = async (archiveAui: string): Promise<void> => {
  const normalizedAui = archiveAui.trim();
  if (!normalizedAui) return;

  try {
    const event = createArchiveViewedEvent({
      eventId: createAnalyticsEventId(),
      occurredAt: new Date().toISOString(),
      archiveAui: normalizedAui,
      ...getAnalyticsIdentity(),
      ...getAnalyticsAttribution(),
    });
    await sendAnalyticsEvent(event);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Failed to send analytics event.', error);
    }
  }
};
